export const SET_AUTH_API_REQUEST = "SET_AUTH_API_REQUEST"
export const SET_AUTH_API_SUCCESS = "SET_AUTH_API_SUCCESS"
export const SET_AUTH_API_FAILURE = "SET_AUTH_API_FAILURE"

export const LOGOUT_ACTION = "[Logout action] logout action"
